module.exports = __webpack_public_path__ + "img/Ambulance.8ef26eaf.svg";